import '../styles/CustomersSurveyConfiguration.scss';
import { Button, Form } from 'react-bootstrap';
import UniInput from '../components/UniInput/UniInput';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Multiselect from 'multiselect-react-dropdown';
import { SaveRequest, get, save } from '../services/customersSurveyConfigurationService';
import UniModal from '../components/UniModal/UniModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmarkCircle, faGear } from '@fortawesome/free-solid-svg-icons';

type MultiselectOptions = {
    name: string,
    id: number
  };

const CustomersSurveyConfiguration = () =>{
    const { i18n, t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [optionsMonthsActive, setOptionsMonthsActive] = useState<MultiselectOptions[]>([]);
    const [monthsActive, setMonthsActive] = useState<number[]>([]);
    const [monthsActiveSelected, setMonthsActiveSelected] = useState<MultiselectOptions[]>([]);
    const [displayQuantity, setDisplayQuantity] = useState<number>(0);    
    const [errorMessage, setErrorMessage] = useState('');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    
    const multiselectRefMonthsActive = useRef<any>(null);

    useEffect(() => {
        getConfiguration();
        getMonthsActiveOptions();
    },[]);

    useEffect(() => {
        getMonthsActiveOptions();
    }, [i18n.language]);

    useEffect(() => {
        const currentMonthsActive = optionsMonthsActive.filter(x => {
            const found = monthsActive.find(m => m === x.id);
            if (found) {
                return x;
            }
            return false;
        });
        setMonthsActiveSelected(currentMonthsActive);
    }, [monthsActive, optionsMonthsActive]);

    const getMonthsActiveOptions = () => {
        setOptionsMonthsActive([
            { id: 1, name: t('customersSurveyConfiguration.january') },
            { id: 2, name: t('customersSurveyConfiguration.february') },
            { id: 3, name: t('customersSurveyConfiguration.march') },
            { id: 4, name: t('customersSurveyConfiguration.april') },
            { id: 5, name: t('customersSurveyConfiguration.may') },
            { id: 6, name: t('customersSurveyConfiguration.june') },
            { id: 7, name: t('customersSurveyConfiguration.july') },
            { id: 8, name: t('customersSurveyConfiguration.august') },
            { id: 9, name: t('customersSurveyConfiguration.september') },
            { id: 10, name: t('customersSurveyConfiguration.october') },
            { id: 11, name: t('customersSurveyConfiguration.november') },
            { id: 12, name: t('customersSurveyConfiguration.december') }
        ]);
    }

    const getConfiguration = () => {
        setLoading(true);
        get()
            .then((response) => {
                setMonthsActive(response.data?.monthsActive);
                setDisplayQuantity(response.data?.displayQuantity); 
            })
            .catch(() => setErrorMessage(t('customersSurveyConfiguration.getErrorMessage')))
            .finally(() => setLoading(false));
    }

    const onChangeMonthsActiveMulti = (e: MultiselectOptions[]) => {
        setMonthsActive(e.map(x => x.id));
    }

    const saveConfiguration = () => {
        setLoading(true);
        save({
            monthsActive: monthsActive.sort(),
            displayQuantity: displayQuantity
        } as SaveRequest)
        .then(m => {
            if(m.success){
                setShowSuccessMessage(true);
            }
        })        
        .catch(e => {setErrorMessage(t('customersSurveyConfiguration.saveErrorMessage')) })
        .finally(() => setLoading(false));
    }    

    return(
        <div className='customers-survey-configuration row'>
            <div className='configuration-wrapper col-lg-12'>
                <div className='header'>
                    <div className='menu-icon'>
                        <FontAwesomeIcon icon={faGear} />
                     </div>
                     <div className='header'>
                     {t('customersSurveyConfiguration.menu')}
                     </div>
                </div>
                <div className='body'>
                    <div className='property'>
                        <Form.Label htmlFor='monthsActive'>{t('customersSurveyConfiguration.monthsActive')}</Form.Label>
                        <Multiselect
                            ref={multiselectRefMonthsActive}
                            options={optionsMonthsActive}
                            selectedValues={monthsActiveSelected}
                            onSelect={(e: any, s: any) => onChangeMonthsActiveMulti(e)}
                            onRemove={(e: any, s: any) => onChangeMonthsActiveMulti(e)}
                            displayValue='name'
                            placeholder={t('select')}
                            disable={loading}
                            hidePlaceholder
                            showCheckbox
                            showArrow
                        />
                    </div>

                    <div className='property'>
                        <UniInput
                            id='displayQuantity'
                            type='number'
                            label={t('customersSurveyConfiguration.displayQuantity')}
                            value={displayQuantity}
                            onChangeInput={(e) => {
                                if (Number(e?.target?.value) >= 0) {
                                    setDisplayQuantity(Number(e.currentTarget.value))
                                }
                            }}
                            disabled={loading}                            
                        />
                    </div>                    

                    <div className='button-save'>
                        <Button
                            onClick={() => saveConfiguration()}
                            disabled={loading}
                            title={t('customersSurveyConfiguration.save')}
                        >
                            {t('customersSurveyConfiguration.save')}
                        </Button>
                    </div>
                </div>
            </div>

            <UniModal
                icon={faCheck}
                isFontAwsome
                iconColor='#00FF3C'
                title={t('customersSurveyConfiguration.saveSuccessMessage')}
                message=''
                show={showSuccessMessage}
                onHide={() => {setShowSuccessMessage(false)}}
                iconWidth={100}
                iconHeight={100}
            >
                <div className='modal-body-resume'>
                    <Button onClick={() => setShowSuccessMessage(false)}>{t('customersSurveyConfiguration.close')}</Button>
                </div>
            </UniModal>

            <UniModal
                icon={faXmarkCircle}
                isFontAwsome
                message=''
                iconColor='#EA2027'
                title={errorMessage}
                onHide={() => { setErrorMessage('') }}
                show={errorMessage !== ''}
                iconWidth={100}
                iconHeight={100}
            >
                <div className='modal-body-resume'>
                    <Button onClick={() => setErrorMessage('') }>{t('customersSurveyConfiguration.close')}</Button>
                </div>
            </UniModal>
        </div>
    );
}

export default CustomersSurveyConfiguration;